import type { AddIcon } from './inline'
import { createIconA11yProps } from './utils'
import type { IconProps as IconPropsType } from './utils'

export const gradients = {
  success: 'success-gradient',
  warning: 'warning-gradient',
  error: 'error-gradient',
  primary: 'primary-gradient',
  secondary: 'secondary-gradient',
  actionPrimary: 'action-primary-gradient',
}

// Re-exports of the small icon-runtime constants so consumers needing
// only these can use the lightweight
// `@twistopayments/design-system/icons/constants` subpath without pulling
// in the full icons umbrella (~700 KB of icon sets). The icons umbrella
// `index.ts` still re-exports everything here for back-compat with anyone
// importing them from `@twistopayments/design-system/icons`.
export { sizes, colors } from './icons.styles'
export const utils = { createIconA11yProps }
export type IconComponent = typeof AddIcon
export type IconProps = IconPropsType
